/*
 * @Author: WLL
 * @Date: 2020-04-20 14:09:26
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-09 15:52:41
 * @Description: 报告相关mixin
 */
import {
  publishDateFormatter,
  getFileType,
  download,
  publishMDDateFormatter,
  getCustomPdfLink,
} from "@/utils";
import EventBus from "@/eventBus";
import { mapGetters } from "vuex";
import da from "element-ui/src/locale/lang/da";
import CustomElTooltip from "@/components/CustomElTooltip";

export default {
  computed: mapGetters(["themeType"]),
  methods: {
    publishDateFormatter,
    publishMDDateFormatter,
    normalRender(h, { row, column }) {
      // el-tooltip 必须有子元素
      return (
        <CustomElTooltip
          class="one-line"
          content={row[column.prop]}
          placement="top"
          effect="light"
        >
          <div>{row[column.prop]}</div>
        </CustomElTooltip>
      );
    },
    ellipsisRender(h, { row, column }) {
      // el-tooltip 必须有子元素
      return (
        <CustomElTooltip
          class="twoLines_ellipsis"
          content={row[column.prop]}
          placement="top"
          effect="light"
          closeAutoShow
        >
          <div>{row[column.prop]}</div>
        </CustomElTooltip>
      );
    },
    ellipsisPointerRender(h, { row, column }) {
      let vRender = h(
        CustomElTooltip,
        {
          class: "twoLines_ellipsis table_cell_a",
          props: {
            placement: "top-start",
            content: row[column.prop],
            effect: "light",
          },
        },
        [h("div", row[column.prop])]
      );
      return vRender;
    },
    renderIncome: (h, { row, column }) => {
      let color;
      if (Number.parseFloat(row[column.prop]) > 0) {
        color = "up_color";
      } else if (Number.parseFloat(row[column.prop]) < 0) {
        color = "down_color";
      } else {
        color = "normal_color";
      }
      return <span class={color}>{`${row[column.prop]}%`}</span>;
    },
    agencyRender(h, { row, column }) {
      const render = (
        <CustomElTooltip
          content={row[column.prop]}
          placement="top"
          effect="light"
          closeAutoShow
          class="table_cell_a"
        >
          <div onClick={(e) => this.onAgencyMixinsClick(e, row)}>
            {row[column.prop]}
          </div>
        </CustomElTooltip>
      );
      return render;
    },
    analystRender(h, { row, column }) {
      const render = (
        <CustomElTooltip
          content={row[column.prop]}
          placement="top"
          effect="light"
          closeAutoShow
          class="table_cell_a"
        >
          <div onClick={(e) => this.onResearcherClick(e, row[column.prop])}>
            {row[column.prop]}
          </div>
        </CustomElTooltip>
      );
      /* (
        <span
          class="table_cell_a"
          title={row[column.prop]}
          onClick={e => this.onResearcherClick(e, row[column.prop])}
        >
          {row[column.prop]}
        </span>
      ); */
      return render;
    },
    researcherRender(h, { row, column }) {
      const researcherList = row[column.prop].split(",");
      /*  const renderList = researcherList.map((item, index) => {
         let rend = (
           <span
             class="researcher-label"
             onClick={e => this.onResearcherClick(e, item)}
           >
             <a className="bottom-driver" title={item}>
               {item}
             </a>
           </span>
         );
         if (index !== researcherList.length - 1) {
           rend = (
             <span
               class="researcher-label"
               onClick={e => this.onResearcherClick(e, item)}
             >
               <a className="bottom-driver" title={item}>
                 {item}
               </a>
               <span>,</span>
             </span>
           );
         } */
      const renderList = researcherList.map((item, index) => {
        let rend = (
          <CustomElTooltip
            content={item}
            placement="top"
            effect="light"
            closeAutoShow
            class="researcher-label"
          >
            <span>
              <a
                onClick={(e) => this.onResearcherClick(e, item)}
                className="bottom-driver"
              >
                {item}
              </a>
            </span>
          </CustomElTooltip>
        );
        if (index !== researcherList.length - 1) {
          rend = (
            <CustomElTooltip
              content={item}
              placement="top"
              effect="light"
              closeAutoShow
              class="researcher-label"
            >
              <span>
                <a
                  onClick={(e) => this.onResearcherClick(e, item)}
                  className="bottom-driver"
                >
                  {item}
                </a>
                <span>,</span>
              </span>
            </CustomElTooltip>
          );
        }
        return rend;
      });
      return <div class="twoLines_ellipsis table_cell_a">{renderList}</div>;
    },
    rankRender: (h, { rowIndex }) => {
      const rankNum = rowIndex + 1;
      return <span>{rankNum}</span>;
    },
    stockRender(h, { row, column }) {
      return (
        <CustomElTooltip
          content={row[column.prop]}
          placement="top"
          effect="light"
          closeAutoShow
          class="table_cell_a"
        >
          <span
            onClick={(e) => this.onStockClick(e, row)}
            class="bottom-driver"
          >
            {row[column.prop]}
          </span>
        </CustomElTooltip>
      );
    },
    ratingRender(h, { row, column }) {
      return (
        <CustomElTooltip
          content={row[column.prop]}
          placement="top"
          effect="light"
          closeAutoShow
          class="table_cell_a"
        >
          <div onClick={(e) => this.onRatingClick(e, row)}>
            {row[column.prop]}
          </div>
        </CustomElTooltip>
      );
    },
    pdfIconRender(h, { row }) {
      const fileType = getFileType(row.URL);
      if (fileType.type === "null") {
        return "";
      }
      return (
        <img
          class={"file_icon " + (fileType.class || "")}
          src={fileType.icon}
          onClick={(e) => this.onPdfClick(e, row)}
        />
      );
    },
    onResearcherClick(e, data) {
      if (e) {
        e.stopPropagation();
      }
      const query = Object.assign({}, this.$route.query, {
        allresearcher: data,
      });
      this.openNewLink({
        name: "stock",
        query,
      });
    },
    onAgencyMixinsClick(e, data) {
      if (e) {
        e.stopPropagation();
      }
      const query = Object.assign({}, this.$route.query, {
        agency_name: data.COMPANYNAME,
      });
      this.openNewLink({
        name: "stock",
        query,
      });
    },
    async onStockClick(e, data) {
      if (e) {
        e.stopPropagation();
      }
      EventBus.$emit("showStockDialog", data);
    },
    async onRatingClick(e, data) {
      if (e) {
        e.stopPropagation();
      }
      // TODO 调整至原系统投资评级
      const params = {
        token: this.$store.state.token,
        domain: this.$store.state.domain,
        keyWord: data.SECURITYCODE || data.V_SECURITYCODE,
        start: 0,
        needCount: 1,
        tagTitle: "上市公司",
        path: "tzpj",
        username: this.$store.state.username,
      };
      const result = await this.$apis.Base.getLinkUrl(params);
      if (result.url) {
        window.open(result.url);
      }
    },
    onPdfClick(e, item) {
      e.stopPropagation();
      if (item.URL) {
        const fileType = getFileType(item.URL);
        if (["pdf"].includes(fileType.type)) {
          let username = this.$store.state.username;
          let nickname = this.$store.state.nickname;
          let url = getCustomPdfLink(item.URL, username, nickname);
          try {
            window.ucf.newTab(url, item.F_NAME, {});
          } catch (e) {
            window.open(url);
          }
        } else {
          download(item.URL, item.F_NAME);
        }
      }
    },
    onReportClick(row, data) {
      const fileType = getFileType(row.URL);
      if (["pdf", "null"].includes(fileType.type) || row.INFOBODYCONTENT) {
        const newQuery = Object.assign(
          {},
          data,
          {
            reportId: row.INFOCODE,
          },
          this.$route.query,
          {
            themeType: this.themeType,
          }
        );
        const link = this.$router.resolve({
          name: "reportDetail",
          query: newQuery,
        });
        const origin = location.origin;
        const finalLink = origin + "/" + link.href;
        try {
          window.ucf.newTab(
            finalLink,
            row.REPORTTITLE || row.V_REPORTTITLE,
            {}
          );
        } catch (e) {
          window.open(finalLink, "_blank");
        }
      } else {
        download(row.URL, row.F_NAME);
      }
    },
    openNewLink(routerData) {
      routerData.query = Object.assign(routerData.query, {
        themeType: this.themeType,
      });
      const link = this.$router.resolve(routerData);
      const origin = location.origin;
      window.open(origin + "/" + link.href, "_blank");
    },
  },
};
